<template>
  <div
    class="tw-grid tw-gap-2 tw-px-4"
    :class="extended ? 'tw-grid-cols-2' : 'tw-grid-cols-1'"
  >
    <div
      v-for="(h, i) in heights"
      :key="i"
      class="tw-grid tw-grid-cols-12 tw-h-auto tw-gap-9 tw-pl-4"
    >
      <div
        v-for="(size, i) in h"
        :key="i"
        class="tw-animate-pulse tw-rounded-sm tw-bg-primary-grey-50 tw-self-end"
        :class="size"
      />
    </div>
    <div
      v-if="!extended"
      class="tw-h-3 tw-animate-pulse tw-rounded-sm tw-bg-primary-grey-50"
    />
  </div>
  <div
    v-if="extended"
    class="tw-h-3 tw-animate-pulse tw-rounded-sm tw-bg-primary-grey-50 tw-mt-2"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

export interface ChartSkeletonProps {
  extended?: boolean;
}

const props = withDefaults(defineProps<ChartSkeletonProps>(), {
  extended: false,
});

const baseHeights = [
  "tw-h-44",
  "tw-h-64",
  "tw-h-20",
  "tw-h-56",
  "tw-h-28",
  "tw-h-12",
  "tw-h-16",
  "tw-h-64",
  "tw-h-56",
  "tw-h-28",
  "tw-h-56",
  "tw-h-10",
];

const heights = computed(() => {
  if (props.extended) {
    return [baseHeights, baseHeights];
  }
  return [baseHeights];
});
</script>
